import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import useSeo from "@/hooks/useSeo";
import MangaCard from "@/components/base/MangaCard";
import { bookLists, mangaList } from "@/mocks/manga";

const hotIds = ["cloud-cafe", "mountain-cat", "time-traveler", "flower-lane", "sword-river", "office-escape"];
const hotManga = hotIds.map((id) => mangaList.find((m) => m.id === id)!).filter(Boolean);

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "笨狗漫画网精选书单",
    url: "https://comicsur.github.io/booklist",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://comicsur.github.io/" },
      { "@type": "ListItem", position: 2, name: "精选书单", item: "https://comicsur.github.io/booklist" },
    ],
  },
];

export default function BooklistPage() {
  useSeo({
    title: "精选书单 - 按主题整理的追更合集 | 笨狗漫画网",
    description:
      "笨狗漫画网精选书单，治愈系、热血冒险、悬疑烧脑、少女恋爱等主题合集，帮你按心情快速找到想追的漫画。",
    jsonLd,
  });

  return (
    <PageLayout>
      <div className="bg-dots">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
          <nav className="flex items-center gap-2 text-sm text-foreground-600" aria-label="面包屑">
            <Link to="/" className="hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
            <span className="text-foreground-950">精选书单</span>
          </nav>

          <div className="mt-4 max-w-2xl">
            <h1 className="font-heading text-3xl text-foreground-950 md:text-4xl">编辑精选书单</h1>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              按不同心情与主题为你整理的好漫合集，治愈、热血、悬疑、恋爱一应俱全，照着书单追准没错。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {bookLists.map((bl) => (
              <div
                key={bl.id}
                className={`group relative overflow-hidden rounded-2xl p-6 text-background-50 transition-transform hover:-translate-y-1 ${
                  bl.color === "primary"
                    ? "bg-primary-500"
                    : bl.color === "accent"
                    ? "bg-accent-500"
                    : "bg-secondary-500"
                }`}
              >
                <i className="ri-stack-line absolute -right-5 -top-5 text-8xl opacity-20" aria-hidden="true"></i>
                <span className="rounded-full bg-background-50/20 px-3 py-1 text-xs">{bl.count} 部作品</span>
                <h2 className="mt-8 font-heading text-2xl">{bl.title}</h2>
                <p className="mt-1 text-sm text-background-50/90">{bl.subtitle}</p>
                <p className="mt-3 line-clamp-3 text-xs leading-relaxed text-background-50/80">{bl.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-14">
            <div className="flex items-end justify-between">
              <div>
                <p className="text-xs font-bold tracking-wide text-accent-600">HOT PICKS</p>
                <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">热门书单收录作品</h2>
              </div>
              <Link to="/rank" className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700">
                去看榜单 <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
              </Link>
            </div>

            <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
              {hotManga.map((manga) => (
                <MangaCard key={manga.id} manga={manga} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}